import Vuex from "vuex";
import axios from 'axios'
import { Url } from './Url'


axios.interceptors.response.use(function (response){
    return response;
},function (error){
    if(error.response.status){
        localStorage.removeItem('token'); 
    }
});

export default new Vuex.Store({
    state: {
        associations : [],
        categories : [],
        places : [],
        publics:[],
        accessibilities:[],
        contexts:[],
        infos:[],
        token: ''
    },
    mutations: {
        loadAssociations(state, associations){
            state.associations = associations;
        },
        logUser(state,user){
            state.token = user.token;
        },
        loadAssociationCategories(state, categories){
            state.categories = categories;
        },
        loadAssociationPlaces(state, places){
            state.places = places;
        },
        associationUpdated(state, updatedAsso) {
            const idx = state.associations.findIndex(a => a.id === updatedAsso.id);
            if (idx !== -1) {
                state.associations.splice(idx, 1, updatedAsso);
            }
        },
        loadInfos(state, infos){
            state.infos = infos;
        },
        loadAssociationPublics(state, publics){
            state.publics = publics;
        },
        loadAssociationAcessibilities(state, accessibilities){
            state.accessibilities = accessibilities;
        },
        loadAssociationContexts(state, contexts){
            state.contexts = contexts;
        }
    },
    actions: {
        login({commit},userLogs){
            return new Promise((resolve, reject) => {
                axios.post(Url.getUrlAuth()+'/login', JSON.stringify(userLogs), {headers: {'Content-Type':'application/json; charset=utf-8'}}).then(response=>{
                    localStorage.setItem("token", JSON.stringify(response.data.token));
                    commit('logUser', response.data);
                    resolve(response)
                }).catch((error)=>{
                    reject(error)
                })
            })
        },

        loadAssociations({commit}){
            axios.get(Url.getUrlApi() + '/association',{
            headers:{
                'Content-Type': 'multipart/form-data',
                'API-Key': 'cle',
                'API-Secret': 'secret',
            }
            }).then(response=> {
                commit('loadAssociations', response.data);
            })
        },

        loadAssociationCategories({commit}){
            axios.get(Url.getUrlApi() + '/association/categories',{
            headers:{
                'Content-Type': 'multipart/form-data',
                'API-Key': 'cle',
                'API-Secret': 'secret',
            }
            }).then(response=> {
                commit('loadAssociationCategories', response.data);
            })
        },

        loadAssociationPublics({commit}){
            axios.get(Url.getUrlApi() + '/association/publics',{
            headers:{
                'Content-Type': 'multipart/form-data',
                'API-Key': 'cle',
                'API-Secret': 'secret',
            }
            }).then(response=> {
                commit('loadAssociationPublics', response.data);
            })
        },

        loadAssociationAccessibilities({commit}){
            axios.get(Url.getUrlApi() + '/association/accessibilities',{
            headers:{
                'Content-Type': 'multipart/form-data',
                'API-Key': 'cle',
                'API-Secret': 'secret',
            }
            }).then(response=> {
                commit('loadAssociationAcessibilities', response.data);
            })
        },

        loadAssociationContexts({commit}){
            axios.get(Url.getUrlApi() + '/association/contexts',{
            headers:{
                'Content-Type': 'multipart/form-data',
                'API-Key': 'cle',
                'API-Secret': 'secret',
            }
            }).then(response=> {
                commit('loadAssociationContexts', response.data);
            })
        },

        loadAssociationPlaces({commit}){
            axios.get(Url.getUrlApi() + '/association/places',{
            headers:{
                'Content-Type': 'multipart/form-data',
                'API-Key': 'cle',
                'API-Secret': 'secret',
            }
            }).then(response=> {
                commit('loadAssociationPlaces', response.data);
            });
        },
        uploadAssociation({commit},association) {
            axios.post(Url.getUrlAdmin() + '/association', association, 
                {headers:{
                    'Content-Type': 'multipart/form-data',
                    'API-Key': 'cle',
                    'API-Secret': 'secret',
                    'Authorization': 'Bearer '+ localStorage.getItem("token").substring(1, localStorage.getItem("token").length -1),
                }
            }).then(response => {
                commit('documentUploaded', response.data);
                this.dispatch('loadAssociations');
            }).catch(error => {
                console.error('Error uploading association:', error);
            });
        },
        updateAssociation({commit},association) {
            axios.put(Url.getUrlAdmin() + '/association', association, 
                {headers:{
                    'Content-Type': 'multipart/form-data',
                    'API-Key': 'cle',
                    'API-Secret': 'secret',
                    'Authorization': 'Bearer '+ localStorage.getItem("token").substring(1, localStorage.getItem("token").length -1),
                }
            }).then(response => {
                commit('documentUploaded', response.data);
                this.dispatch('loadAssociations');
            }).catch(error => {
                console.error('Error uploading association:', error);
            });
        },
        deleteAssociation({dispatch}, id){
            axios.delete(Url.getUrlAdmin()+'/association/'+id, {
                headers:{
                    'API-Key': 'cle',
                    'API-Secret': 'secret',
                    'Authorization': 'Bearer '+ localStorage.getItem("token").substring(1, localStorage.getItem("token").length -1),
                }
            })
            .then(() => {
                return dispatch('loadAssociations')
            })
            .catch(error => {
                console.error('Error deleting association:', error)
                throw error
            })
        },
        loadInfos({ commit }) {
            axios.get(Url.getUrlApi() + '/info', {
              headers: {
                'Content-Type': 'multipart/form-data',
                'API-Key': 'cle',
                'API-Secret': 'secret',
              }
            })
            .then(response => {
              const sortedInfos = response.data.slice()
                .sort((a, b) => {
                  // on cherche le nombre avant le point dans "1. CPAS : …"
                  const numA = parseInt((a.name.match(/^(\d+)\./) || [0, 0])[1], 10);
                  const numB = parseInt((b.name.match(/^(\d+)\./) || [0, 0])[1], 10);
                  return numA - numB;
                });
              commit('loadInfos', sortedInfos);
            })
            .catch(err => {
              console.error('Erreur en récupérant les infos :', err);
            });
          },
        uploadInfo({commit},info) {
            axios.post(Url.getUrlAdmin() + '/info', info, 
                {headers:{
                    'Content-Type': 'multipart/form-data',
                    'API-Key': 'cle',
                    'API-Secret': 'secret',
                    'Authorization': 'Bearer '+ localStorage.getItem("token").substring(1, localStorage.getItem("token").length -1),
                }
            }).then(response => {
                commit('infoUploaded', response.data);
                this.dispatch('loadInfos');
            }).catch(error => {
                console.error('Error uploading association:', error);
            });
        },
        deleteInfo({dispatch}, id){
            axios.delete(Url.getUrlAdmin()+'/info/'+id, {
                headers:{
                    'API-Key': 'cle',
                    'API-Secret': 'secret',
                    'Authorization': 'Bearer '+ localStorage.getItem("token").substring(1, localStorage.getItem("token").length -1),
                }
            })
            .then(() => {
                return dispatch('loadInfos')
            })
            .catch(error => {
                console.error('Error deleting info:', error)
                throw error
            })
        },
        updateInfo({commit},info) {
            axios.put(Url.getUrlAdmin() + '/info', info, 
                {headers:{
                    'Content-Type': 'multipart/form-data',
                    'API-Key': 'cle',
                    'API-Secret': 'secret',
                    'Authorization': 'Bearer '+ localStorage.getItem("token").substring(1, localStorage.getItem("token").length -1),
                }
            }).then(response => {
                commit('infoUploaded', response.data);
                this.dispatch('loadInfos');
            }).catch(error => {
                console.error('Error uploading info:', error);
            });
        },
    },
    getters:{
        getAssociations:state=>{return state.associations},
        getCategories: state=>{return state.categories},
        getPlaces: state=>{return state.places},
        getPublics: state=>{return state.publics},
        getAccessibilities: state=>{return state.accessibilities},
        getContexts: state=>{return state.contexts},
        getToken:state=>{return state.token},
        getInfos:state=>{return state.infos}
    },
    modules: {
    }
})
